import BuildingSvg from '@assets/images/svg/building.svg';
import React from 'react';
import { View } from 'react-native';

export interface BuildingIconProps {
    size?: number;
    color?: string;
}

export function BuildingIcon({ size = 24, color = '#333333' }: BuildingIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <BuildingSvg width={size} height={size} color={color} />
        </View>
    );
}

export default BuildingIcon;